import { get } from 'lodash';

import Model from 'models';

const PageSectionEmailSignupModule = class extends Model {
  get type() {
    return get(this._data, '_contentType');
  }

  get text() {
    return get(this._data, 'text');
  }

  get disclaimer() {
    return get(this._data, 'disclaimer');
  }

  get backgroundColor() {
    return get(this._data, 'backgroundColor');
  }

  get marketingMessage() {
    return get(this._data, 'marketingMessage');
  }
};

export default PageSectionEmailSignupModule;
